module.exports.env={
  google_client_id:'545443912834-vqgc2gtl87p14jdisj6j1iehcd21funi.apps.googleusercontent.com',
  backend:'https://gipo.boti.bot',
  frontend:'https://gipo.boti.bot',
}
